<div class="ticket-container">
  <div class="registration-cost">
    <span>{{ discountText }}</span>
    <span>{{ eventPrice | currency:'USD':true:'1.2-2' }}</span>
  </div>
  @if (hasAnyDiscount) {
    <div class="ticket">
      <p class="title">Members pay less</p>
      @if (!loading) {
        <div class="pricing">
          <div class="price-line">
            <span>Standard (No discount):</span>
            <span>{{ standardPrice | currency:'USD':true:'1.2-2'}}</span>
          </div>
          <div class="price-line">
            <span>Gold{{goldDiscountPercent > 0 ? ' ('+goldDiscountPercent+'% off)' : ''}}:</span>
            <span>{{ goldPricing | currency:'USD':true:'1.2-2'}}</span>
          </div>
          <div class="price-line">
            <span>Platinum{{platinumDiscountPercent > 0 ? ' ('+platinumDiscountPercent+'% off)' : ''}}:</span>
            <span>{{ platinumPricing | currency:'USD':true:'1.2-2'}}</span>
          </div>
        </div>
        @if (!userService.isPlatinumMember()) {
          <div class="actions">
            @if (!userService.loggedIn) {
              <a routerLink="/membership">Become a member</a> or <a routerLink="/login">Login</a> to access discounts
            }
            @if (userService.isFreeMember()) {
              <a routerLink="/membership">Become a member</a> to access discounts
            }
            @if (userService.isGoldMember()) {
              <a routerLink="/membership">Upgrade to a Platinum Membership</a> to save even more
            }
          </div>
        }
      }
    </div>
  }
</div>
